@if (!IsLoginPageActive()) {
<header
  [ngClass]="theme.getThemeClass()"
  class="navbar navbar-expand navbar-light bg-light px-2"
>
  <!-- Dropdown menu for smaller screens -->
  @if (smallscreen) {
  <div class="burger-menu">
    
    <a
      class="nav-link dropdown-toggle"
      href="javascript:void(0);"
      data-bs-toggle="dropdown"
    >
      <i class="fa fa-bars"></i>
    </a>
    <ul
      [ngClass]="theme.getThemeClass()"
      class="ulDrop dropdown-menu dropdown-menu-light"
    >
      <!-- Menu Items -->
      @for (item of nav.list; track item.routeUrl) {
      <li>
        <a
          [ngClass]="theme.getThemeClass()"
          class="dropdown-item"
          [routerLink]="['/', item.routeUrl]"
        >
          <i class="textAlignCenter" [ngClass]="item.icon"></i>
          <span class="customMarginLeft1">
            {{ item.mobile | translate }}
          </span>
        </a>
      </li>
      }
      <li style="cursor: pointer">
        <a
          [ngClass]="theme.getThemeClass()"
          class="dropdown-item"
          (click)="openChat()"
        >
          <i class="textAlignCenter fa-regular fa-comments"></i>
          <span class="customMarginLeft1">
            {{ "sidenavMenu.CHAT" | translate }}
          </span>
        </a>
      </li>
    </ul>
    
  </div>
  }
  <!-- Brand logo -->
  <!-- TODO What is the purpuse of this nav block ???-->
  <nav class="hideee">
    <!--  for the link below. Functionality moved to the side-nav component (click)="SideNavToggle()"  -->
	    <a
	      [ngClass]="theme.getThemeClass()"
	      class="hide-too-small-screen navbar-brand px-1"
	      href="javascript:void(0);"
	      >@if (!smallscreen) {
	        <img class="header-logo hides" src="../assets/muirwood-studio.png" />
	      }</a>

    <ul
      [ngClass]="theme.getThemeClass()"
      class="ulDrop dropdown-menu dropdown-menu-light"
    >
      <!-- Menu Items -->
      @for (item of nav.list; track item.routeUrl) {
      <li>
        <a
          [ngClass]="theme.getThemeClass()"
          class="dropdown-item"
          [routerLink]="['/', item.routeUrl]"
        >
          <i class="textAlignCenter" [ngClass]="item.icon"></i>
          <span class="customMarginLeft1">
            {{ item.mobile | translate }}
          </span>
        </a>
      </li>
      }
      <li style="cursor: pointer">
        <a
          [ngClass]="theme.getThemeClass()"
          class="dropdown-item"
          (click)="openChat()"
        >
          <i class="textAlignCenter fa-regular fa-comments"></i>
          <span class="customMarginLeft1">
            {{ "sidenavMenu.CHAT" | translate }}
          </span>
        </a>
      </li>
    </ul>
  </nav>

  <!-- Navbar items -->
  <nav class="navbar-collapse">
    <ul class="navbar-nav me-auto">
      <!-- Navbar items go here -->
    </ul>
  </nav>

  <!-- Chat Notification element -->
  @if (this.smallscreen) {
  <div
    (touchstart)="openChat()"
    (click)="openChat()"
    [ngStyle]="
      chatService.getUnreadCount(undefined, 'all') > 0
        ? {
            border: '1px solid red',
            'background-color': 'red'
          }
        : {}
    "
    class="notification"
  >
    <i class="fa-regular fa-comments">
      <span class="notification-number">
        {{ this.chatService.getUnreadCount(undefined, "all") }}
      </span>
    </i>
  </div>
  }

  <!-- Notifications button -->
  <button
    [ngClass]="theme.getThemeClass()"
    type="button"
    class="btn btn-outline-dark position-relative customNotificationBtn1 notificationElement"
    (click)="showNotificationsDropdown()"
  >
    <i class="far fa-bell font20"></i>
    @if (this.notificationService.unreadNotificationsCount > 0) {
    <span
      class="badge position-absolute translate-middle rounded-pill badge-danger notificationElement"
    >
      {{ this.notificationService.unreadNotificationsCount }}
    </span>
    }
  </button>

  <!-- User status -->
  <div
    class="user-status-container"
    (click)="toggleStatusDropdown()"
    tabindex="0"
    (blur)="dropdownOpen = false"
  >
    <!-- Current status Bubble -->
    <div class="status-display">
      <div
        class="status-indicator"
        [ngStyle]="{
          'background-color': inactivityService.statusColors[selectedStatus]
        }"
      ></div>
    </div>

    <!-- Status Dropdown -->
    @if (dropdownOpen) {
    <div [ngClass]="theme.getThemeClass()" class="status-dropdown">
      @for (status of inactivityService.statuses; track status) {
      <div
        class="status-option"
        (mousedown)="setStatus(status)"
        [ngClass]="{ selectedStatus: selectedStatus === status }"
      >
        <div
          class="status-indicator"
          [ngStyle]="{
            'background-color': inactivityService.statusColors[status]
          }"
        ></div>
        {{ status | translate }}
      </div>
      }
    </div>
    }
  </div>

  <!-- User profile dropdown -->
  <div class="profile-logo dropstart">
    <button
      class="btn btn-outline-gray customUserProfileBtn1"
      data-bs-toggle="dropdown"
    >
      <a
        [ngClass]="theme.getThemeClass()"
        class="dropdown-item textAlignCenter customPaddingTop"
        >{{ userName }}</a
      >
    </button>
    <ul
      [ngClass]="theme.getThemeClass()"
      class="dropdown-menu dropdown-menu-light customUserProfileBtn2"
    >
      <!-- Dropdown menu items -->
      <li>
        <a
          [ngClass]="theme.getThemeClass()"
          [routerLink]="['/', 'user-edit']"
          class="dropdown-item verticalAlignMiddle"
        >
          {{ "headerUserMenuMyAccount" | translate }}
        </a>
      </li>
      <li>
        <a
          [ngClass]="theme.getThemeClass()"
          [routerLink]="['/', 'user-edit-preference']"
          class="dropdown-item verticalAlignMiddle"
        >
          {{ "deviceAlert" | translate }}
        </a>
      </li>
      <li (click)="$event.stopPropagation()">
        <a
          [ngClass]="theme.getThemeClass()"
          href="javascript:void(0);"
          class="dropdown-item verticalAlignMiddle"
        >
          {{ "headerUserMenuTheme" | translate }}
          <label class="switch verticalAlignMiddle mb-2">
            <input
              type="checkbox"
              id="toggleDarkMode"
              [checked]="theme.isSwitchOn"
              (change)="toggleDarkMode($event)"
            />
            <span class="slider"></span> </label
        ></a>
      </li>
      <li>
        <a
          [ngClass]="theme.getThemeClass()"
          class="dropdown-item verticalAlignMiddle"
          (click)="clearStorage()"
        >
          {{ "headerUserMenuLogOut" | translate }}
        </a>
      </li>
    </ul>
  </div>
</header>
}
<!-- Notification list component -->
@if (this.displayNotificationList) {
<app-notification-list
  class="appDeviceModal notificationElement"
></app-notification-list>
}
